module.exports = __webpack_public_path__ + "img/Stemness-OVCA_GSE227019.798c527b.png";